export default "__VITE_ASSET__CyfFQjiR__"